import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { ConfigBankPopupComponent } from '../config-bank-inquiry/config-bank-popup/config-bank-popup.component';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service'
import { SubDistrictManagePopupComponent } from './sub-district-manage-popup/sub-district-manage-popup.component';
import { Router } from '@angular/router';
import { AppMenuService } from 'app/business/service/app/app-menu.service';
import { AppUserService } from 'app/business/service/app/app-user.service';
import { ConfirmDialogService } from '@bundle/component/confirm-dialog/confirm-dialog.service';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
  selector: 'app-sub-district-manage-inquiry',
  templateUrl: './sub-district-manage-inquiry.component.html',
  styleUrls: ['./sub-district-manage-inquiry.component.css']
})
export class SubDistrictManageInquiryComponent implements OnInit, AfterViewInit {
  BenefitTarget: any = [];
  provinceList: any = [];
  districtList: any = [];
  form: any = {};
  BenefitTargetValue: string;
  displayedColumns: string[] = ['select', 'subDistrictCode', 'subDistrictName', 'subDistrictEname', 'districtName', 'provinceName', 'action'];
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  url: any;
  buttonList: any[] = [];
  itemList: any[]
  userProfile:any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private appMasterService: AppMasterService,
    private alertMessageService: AlertMessageService,
    private router: Router,
    private appMenuService: AppMenuService,
    private appUserService: AppUserService,
    private confirmDialogService: ConfirmDialogService,
    private _authService:AuthService,
  ) { }

  async getRouter(): Promise<void> {
    
    this.url = this.router.url;

    const formData = {
      url: this.url,
      userGroupCode: this.userProfile.userGroupCode,
      userRoleCode: this.userProfile.userRoleCode,
      userCode: this.userProfile.userCode
    };
    this.buttonList = await this.appMenuService.getButtonPermissionPerPages(formData);
    
  }
  
  checkButton(buttonCode: string) {
    var checkBtn = this.buttonList.find(e => e.buttonCode == buttonCode);

    if (checkBtn != undefined) {
      return true;
    } else {
      return false;
    }
  }

  async ngOnInit() {
    this.userProfile = JSON.parse(
      this._authService.loginUser
    )
    await this.getRouter();
    this.BenefitTarget = [{ benefitTargetCode: 1, benefitTargetTName: '10' }, { benefitTargetCode: 2, benefitTargetTName: '20' }];
    this.form.isActive = 'A';
    this.loadProvince();
    this.loadDistrict();
    this.loadData();
  }

  loadData() {
    const data = {
      "subDistrictCode": this.form.subDistrictCode,
      "subDistrictName": this.form.subDistrictName,
      "subDistrictEname": this.form.subDistrictEname,
      "subDistrictDgaCode": this.form.subDistrictDgaCode,
      "provinceId": this.form.provinceId,
      "districtId": this.form.districtId
    };

    this.appMasterService.getMasterSubDistrictList(data).then((res: any) => {
      if (res === "error") {
        return;
      } else {
        this.itemList = res;
        this.dataSource = new MatTableDataSource(res)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
      }
    })
  }

  loadProvince() {
    this.appMasterService.getMasterProvince({}).then(res => {
      if (res === "error") {
        return;
      } else {
        this.provinceList = res;

        const CheckAll = this.provinceList.find(element => element.provinceName === "ทั้งหมด");
        if (CheckAll === undefined) {
          this.provinceList.unshift({ "provinceId": 0, "provinceName": "ทั้งหมด" });
        }
      }
    });
  }

  loadDistrict() {
    const data = {
      "provinceId": this.form.provinceId,
    };

    this.appMasterService.getMasterDistrictList(data).then(res => {
      if (res === "error") {
        return;
      } else {
        this.districtList = res;

        const CheckAll = this.districtList.find(element => element.districtName === "ทั้งหมด");
        if (CheckAll === undefined) {
          this.districtList.unshift({ "id": 0, "districtName": "ทั้งหมด" });
        }
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onProvinceChange(e) {
    if (e.value === 0) {
      this.form.provinceId = null;
      this.form.districtId = null;
    } else {
      this.form.provinceId = e.value;
      this.form.districtId = null;
    }

    this.loadDistrict();
    this.loadData();
  }

  onDistrictChange(e) {
    if (e.value === 0) {
      this.form.districtId = null;
    } else {
      this.form.districtId = e.value;
    }

    this.loadData();
  }

  editItem(e) {
    const data = { ...e };
    const dialogRef = this.dialog.open(SubDistrictManagePopupComponent, {
      disableClose: false,
      width: '60vw',
      data: data,
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.loadData();
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
    
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filterValue?.length > 0) {
      var res = this.itemList.filter(e => (e.subDistrictDgaCode.toLowerCase().includes(filterValue) || e.subDistrictName.toLowerCase().includes(filterValue) || e.subDistrictEname.toLowerCase().includes(filterValue)));

      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else {
      this.dataSource = new MatTableDataSource(this.itemList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  formatCurrency(value: number) {
    return new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      currencyDisplay: "code",
    })
      .format(value)
      .replace("THB", "")
      .trim();
  }

  save() {

  }

  addAccount(data): void {
    const dialogRef = this.dialog.open(SubDistrictManagePopupComponent, {
      disableClose: false,
      width: '60vw',
      data: null,
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadData();
      }
      this.selection.clear(true);
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  delete(e) {
    this.confirmDialogService.open({ header: "", content: "คุณต้องการลบข้อมูลนี้หรือไม่?" }).then(res => {
      if (res) {
        const data = {
          id: e.id,
          subDistrictDgaCode: e.subDistrictDgaCode,
          subDistrictName: e.subDistrictName,
          subDistrictEname: e.subDistrictEname,
          postalCode: e.postalCode,
          provinceId: e.provinceId,
          districtId: e.districtId,
          isActive: "N"
        };

        this.appMasterService.saveSubDistrict(data).then((res: any) => {
          if (res === "error") {
            return;
          } else {
            this.loadData();
          }
        });
      }
    });
  }

  deleteSelection() {
    if (this.selection?.selected?.length > 0) {
      this.confirmDialogService.open({ header: "", content: "คุณต้องการลบข้อมูลนี้หรือไม่?" }).then(res => {
        if (res) {
          var selectedKey = this.selection.selected.map((item, index, chats) => {
            return {
              id: item.id,
              subDistrictDgaCode: item.subDistrictDgaCode,
              subDistrictName: item.subDistrictName,
              subDistrictEname: item.subDistrictEname,
              postalCode: item.postalCode,
              provinceId: item.provinceId,
              districtId: item.districtId,
              isActive: "N"
            }
          });

          const req = {
            saveList: selectedKey
          };

          this.appMasterService.updateSubDistrictBatch(req).then(res => {
            if (res === 'error') {
              this.alertMessageService.open({ message: "เกิดข้อผิดพลาดระหว่างบันทึกข้อมูล", title: "ข้อผิดพลาด" });
            } else {
              this.selection.clear(true);
              this.loadData();
            }
          });

        }
      });
    } else {
      this.alertMessageService.open({ message: "กรุณาเลือกรายการที่จะลบข้อมูล", title: "ข้อผิดพลาด" });
    }
  }
}
